import { HttpClient } from "../core/request"

// ------------------------------------
// Constants
// ------------------------------------
export const FORGOT_FORM_CHANGE_VISIBLE = 'FORGOT_FORM_CHANGE_VISIBLE';

// ------------------------------------
// Actions
// ------------------------------------
export function forgotPasswordFormVisible (show = false) {
  return {
    type    : FORGOT_FORM_CHANGE_VISIBLE,
    payload : show
  }
}

export const forgot = (email) => {
    return (dispatch, getState) => {
        return HttpClient().post('account/reset-password', {
            email: email
        });
    }
};

// ------------------------------------
// Reducer
// ------------------------------------
export function forgotFormReducer (state = false, action) {
    return action.type === FORGOT_FORM_CHANGE_VISIBLE
        ? action.payload
        : state
}



// WEBPACK FOOTER //
// ./src/store/forgotPassword.js